var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-empty',{attrs:{"description":_vm.description,"image":_vm.imgSrc || require('./empty.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }